import * as React from 'react';

import { Box } from '@coursera/coursera-ui';

import ToggleContainer from 'bundles/account-settings/components/sections/highlights/ToggleContainer';

import _t from 'i18n!nls/account-settings';

import 'css!./__styles__/Setting';

type Props = {
  ctaTitle: string;
  description: string;
  onText: string;
  offText: string;
  onToggle: (newStatus: 'on' | 'off') => void;
  enabled?: boolean;
};

const NOTES_AND_HIGHLIGHTS_DESCRIPTION = 'notes-highlights-description';

const Setting = ({ ctaTitle, description, onText, offText, onToggle, enabled }: Props) => {
  return (
    <div className="rc-Setting">
      <Box justifyContent="between">
        <h3
          className="display-2-text section-title"
          aria-label={_t('#{toggleText} #{ctaTitle}', { ctaTitle, toggleText: enabled ? onText : offText })}
        >
          {ctaTitle}
        </h3>
        <ToggleContainer
          onText={onText}
          offText={offText}
          onToggle={onToggle}
          enabled={enabled}
          ariaDescribedBy={NOTES_AND_HIGHLIGHTS_DESCRIPTION}
          ariaLabel={_t('#{ctaTitle}', { ctaTitle })}
        />
      </Box>
      <div id={NOTES_AND_HIGHLIGHTS_DESCRIPTION} className="description">
        {description}
      </div>
    </div>
  );
};

export default Setting;
